module.exports = __webpack_public_path__ + "img/ic-error.3a5ae1f8.png";